import { WorkspaceParams } from '@/backend/access/workspace/types';
import { File } from './file';

export class Workspace {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  title: string;
  description: string;
  ownerFusaOrgId: string;
  executorEnterpriseId: string;
  file?: File;
  propelOrgId: string;
  
  constructor(params: WorkspaceParams) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.title = params.title;
    this.description = params.description;
    this.ownerFusaOrgId = params.ownerFusaOrgId;
    this.executorEnterpriseId = params.executorEnterpriseId;
    this.file = params.file ? new File(params.file) : undefined;
    this.propelOrgId = params.propelOrgId || '';
  }
}
